import { render, staticRenderFns } from "./register_qc.vue?vue&type=template&id=388f5647&scoped=true"
import script from "./register_qc.vue?vue&type=script&lang=js"
export * from "./register_qc.vue?vue&type=script&lang=js"
import style0 from "./register_qc.vue?vue&type=style&index=0&id=388f5647&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388f5647",
  null
  
)

export default component.exports